/* eslint-disable */
import React, { useState } from 'react'
import { ContainerModalSetFilter, TextFieldStyle } from './ModalFilter.style'

const ModalFilterDate = ({ onModelChange, name1, name2 }) => {
  const [date, setDate] = useState({ [name1]: '', [name2]: '' })

  const valueChanged = event => {
    const { name, value } = event.target
    const copyDate = { ...date }
    copyDate[name] = value
    if (!Object.values(copyDate).includes('')) {
      onModelChange(copyDate)
    } else {
      const newDatesValues = Object.values(copyDate).filter(v => v !== '')
      const datesValues = Object.values(date).filter(v => v !== '')
      if (datesValues.length === 2 && newDatesValues.length === 1) {
        onModelChange({ [name1]: '', [name2]: '' })
      }
    }
    setDate(copyDate)
  }

  return (
    <ContainerModalSetFilter>
      <TextFieldStyle
        type="date"
        name={name1}
        value={date[name1]}
        placeholder="dd-mm-yyyy"
        onChange={valueChanged}
      />
      <TextFieldStyle
        type="date"
        name={name2}
        value={date[name2]}
        placeholder="dd-mm-yyyy"
        onChange={valueChanged}
      />
    </ContainerModalSetFilter>
  )
}

export default ModalFilterDate
